module.exports = __webpack_public_path__ + "static/media/external.0f15c73a.svg";